module.exports = __webpack_public_path__ + "img/ensemble.e2d7c758.jpg";